import { useMemo } from 'react';
import { TokenDistributionSummary } from '../../../types';
import { DonutChartData } from '@silverfort/sf-components/dist/Charts/DonutChart/types';
import { AUTHENTICATOR_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { AuthenticatorType } from '../../../../../containers/LogsDrawer/types';
import { ChartColors } from '@silverfort/sf-components';

const TOKEN_TO_COLOR_MAP = {
    [AUTHENTICATOR_TYPES.CHROME.value]: ChartColors['data-bg-main-1'],
    [AUTHENTICATOR_TYPES.DUO.value]: ChartColors['data-bg-main-2'],
    [AUTHENTICATOR_TYPES.MICROSOFT.value]: ChartColors['data-bg-main-3'],
    [AUTHENTICATOR_TYPES.MOBILE.value]: ChartColors['data-bg-main-4'],
    [AUTHENTICATOR_TYPES.OKTA.value]: ChartColors['data-bg-main-5'],
    [AUTHENTICATOR_TYPES.PING.value]: ChartColors['data-bg-main-6'],
    [AUTHENTICATOR_TYPES.RSA.value]: ChartColors['data-bg-main-7'],
    [AUTHENTICATOR_TYPES.DESKTOP.value]: ChartColors['data-bg-main-8'],
    [AUTHENTICATOR_TYPES.OTP.value]: ChartColors['data-bg-main-9'],
    [AUTHENTICATOR_TYPES.WEBAUTHN.value]: ChartColors['data-bg-main-10'],
    [AUTHENTICATOR_TYPES.HYPR.value]: ChartColors['data-bg-main-11'],
    [AUTHENTICATOR_TYPES.EXTERNAL_PUSH.value]: ChartColors['data-bg-main-12'],
    [AUTHENTICATOR_TYPES.EXTERNAL_OTP.value]: ChartColors['data-bg-main-13'],
    [AUTHENTICATOR_TYPES.RADIUS_OTP.value]: ChartColors['data-bg-main-14'],
    [AUTHENTICATOR_TYPES.BRIDGE_SSO.value]: ChartColors['data-bg-main-15']
};

export const useTokensDistributionData = (
    onClick: (token: AuthenticatorType) => void,
    tokenDistributionSummary?: TokenDistributionSummary
) => {
    return useMemo(() => {
        return Object.entries(tokenDistributionSummary ?? {}).map(([key, value]) => ({
            name: Object.values(AUTHENTICATOR_TYPES).find(({ value }) => value === key)?.label,
            value,
            fill: TOKEN_TO_COLOR_MAP[key],
            onClick: () => onClick(key as AuthenticatorType),
            tooltipContent: `${Object.values(AUTHENTICATOR_TYPES).find(({ value }) => value === key)?.label}: ${value}`,
            tooltipPlacement: 'top-start'
        }));
    }, [tokenDistributionSummary]) as DonutChartData[];
};
